import React, { Component } from "react";
import warning_amber from "@safecv/assets/Images/warning_amber.png";
import "./PlanError.css";

class PlanError extends Component {
  render() {
    return (
      <div className="container">
        <img
          className="verification-error-icon"
          src={warning_amber}
          alt="error msg"
        ></img>
        <div className="verification-error-msg">
          {this.props.reasonForFailure}
        </div>
        <div className="verification-error-short">{this.props.description}</div>
      </div>
    );
  }
}

export default PlanError;
